// @flow
import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";

import { withSignedInRedirect } from "v2/routes/wrappers";

import * as pages from "v2/pages";
import NotFound from "v2/components/NotFound";

const routes = [
  {
    path: "/slack/install",
    component: pages.SlackInstall,
    exact: true
  },
  {
    path: "/google/authenticate",
    component: pages.GoogleAuthenticate,
    exact: true
  },
  {
    path: "/slack/authenticate",
    component: pages.SlackAuthenticate,
    exact: true
  },
  {
    path: "/login",
    component: withSignedInRedirect(pages.SessionLogin),
    exact: true
  },
  {
    path: "/signup",
    component: withSignedInRedirect(pages.SessionSignup),
    exact: true
  },
  {
    path: "/confirm",
    component: pages.SessionConfirm,
    exact: true
  },
  {
    path: "/password/reset",
    component: pages.SessionResetPassword,
    exact: true
  },
  {
    path: "/password/new",
    component: pages.SessionNewPassword,
    exact: true
  },
  {
    component: NotFound
  }
];

type Props = {};

class MainPublicRoutes extends Component<Props> {
  // This class doesn't need to fetch the currentWorkspace because it should have been done already in _workspaceApps
  // We're also assuming that the user is not logged in.

  // We can safely render the routes directly

  render() {
    return (
      <Switch>
        {routes.map(route => (
          <Route key={route.path || "notfound"} {...route} />
        ))}
      </Switch>
    );
  }
}

export default MainPublicRoutes;
